<template>
  <div class="lib__header__grid--img-text-container ">
    <slot></slot>
    <p class="lib__header__grid--text lib__text-info lib__no-margin">{{ header }}</p>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'resume-offering-header'
})
export default class ResumeOfferingHeader extends Vue {
  @Prop({ type: String, required: true }) public header!: string
}
</script>
